
import { Placement } from '@post-office/placements-frontend/jira-issue-view-playbooks-panel';
export default Placement;
